export default function Component_Products() {
  return (
    <section
      className="
        relative w-full
        min-h-[320px] lg:min-h-[420px]
        flex items-center justify-center
        bg-cover bg-center bg-no-repeat
      "
      style={{
        backgroundImage: "url('/frameproduct.png')"
      }}
    >
      <div className="relative z-10 max-w-2xl px-6 text-center">
        
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">
          Need help picking the <br className="hidden sm:block" />
          right product?
        </h2>

        <p className="mt-4 text-gray-700 text-sm sm:text-base">
          Our studio helps you select the right product, fabric,
          and customization based on usage.
        </p>

        <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
  
  {/* Talk To Studio - Direct Call */}
  <a
    href="tel:8080907304"
    className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-3 transition text-center"
  >
    Talk to the Studio
  </a>

  {/* Chat on WhatsApp */}
  <a
    href="https://wa.me/918080907304?text=Hi%20I%20am%20interested%20in%20your%20apparel%20services"
    target="_blank"
    rel="noopener noreferrer"
    className="border border-black px-8 py-3 hover:bg-black hover:text-white transition text-center"
  >
    Chat on WhatsApp
  </a>

</div>


      </div>
    </section>
  );
}
